import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';

import { SaveBookmarkDialogComponent } from './save-bookmark-dialog.component';

@NgModule({
  imports: [CommonModule, MaterialModule, SharedModule, ReactiveFormsModule],
  declarations: [SaveBookmarkDialogComponent],
  exports: [SaveBookmarkDialogComponent],
  entryComponents: [SaveBookmarkDialogComponent],
})
export class SaveBookmarkDialogModule {}
